<template>
    <div class="supply-item" :class="{ error: (form_error) ? true : false }" v-show="is_showing">
        <div @click="showLargerImage">
            <img :src="data.supply_thumbnail_file" class="supply-thumbnail" />
        </div>

        <div class="supply-description">
            <label class="header-label">{{ data.supply_desc }}</label>
            <div class="supply-details description" v-if="data.detailed_desc">
                {{ data.detailed_desc }}
            </div>
            <div class="supply-additional-info" v-if="data.additional_info">
                <label>Tests Included in Package:</label>
                {{ data.additional_info }}
            </div>
            <div class="supply-important-info m-t-10" v-if="data.important_info">
                <label>Important!</label>
                {{ data.important_info }}
            </div>
        </div>

        <div class="text-right" v-if="data.quantity_max !== 0">
            <div class="m-b-5">Price: ${{ formattedPrice }}</div>
            <div>
                Qty:
                <div class="inline">
                    <div class="fg-line">
                        <select class="form-control supply-qty inline" :value="value" @change="quantityChangeHandler" v-if="quantityOptions.length > 0">
                            <option value="0">0</option>
                            <option v-for="option in quantityOptions" :value="option">{{ option }}</option>
                        </select>
                        <input type="text" class="form-control supply-qty inline" :value="value" @change="quantityChangeHandler" v-else />
                    </div>
                </div>
            </div>
            <div class="simple-error" v-if="form_error">
                {{ form_error }}
            </div>
        </div>
        <div class="supply-remove-container text-xl">
            <div class="supply-remove" @click="remove">
                <i class="fa fa-times"></i>
            </div>
        </div>

        <div class="modal fade" ref="modal" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-contents">
                    <div class="close close-supply-image" data-dismiss="modal" aria-label="Close">
                        <i class="fa fa-close"></i>
                    </div>
                    <img :src="data.supply_image_file" class="supply-image" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .supply-item {
        display: flex;
        flex-direction: row;

        &.error {
             box-shadow: 0px 0px 1px $danger-red;
        }
    }

    .supply-item > *:nth-child(2) {
        flex: 1;
    }

    .supply-important-info {
        color: $danger-red;
    }

    .supply-thumbnail {
        height: 75px;
        width: 95px;
        border: 2px solid $border-gray;
        cursor: pointer;
    }

    .close-supply-image {
        color: #ffffff;
        position: absolute;
        top: 3px;
        right: 5px;
    }

    .supply-image {
        max-width: 100%;
        height: auto;
        border: 2px solid $dark-blue;
    }

    .supply-description {
        padding: 0px $con-pad-md;
    }

    .supply-qty {
      width: 75px;
    }

    .supply-remove-container {
        position: relative;
        padding-left: $con-pad-lg;
    }

    .supply-remove {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
        color: $med-blue;
    }

    .supply-details {
        display: block;
        position: relative;
        padding: 0 25px 0 0;

        &.description {
             color: lighten($body-text,10%);
        }
    }

    .supply-additional-info {
        display: block;
        position: relative;
        margin-top: 5px;
        color: lighten($body-text,15%);
    }

    @media (max-width: $break-xs) {
        .supply-thumbnail {
            height: 50px;
        }
    }

</style>


<script>
    export default{
        props: {
            index: {},
            data: { default: null },
            value: {},
            is_showing: { type: Boolean, default: true }
        },

        data: function() {
            return {
                form_error: null,
                modal: null
            }
        },

        computed: {
            quantityOptions: function() {
                if (this.data.quantity_opts) {
                    return this.data.quantity_opts.replace(/\s/g,'').split(',');
                }
                return [];
            },

            quantityAllowed: function() {
                return {
                    min: (this.data.quantity_min) ? this.data.quantity_min : null,
                    max: (this.data.quantity_max) ? this.data.quantity_max : null
                }
            },

            formattedPrice: function() {
                return parseFloat(this.data.price).toFixed(2);
            }
        },

        methods: {
            quantityChangeHandler: function(event) {
                this.form_error = null;
                var value = event.target.value;
                if (!value || isNaN(value) || parseInt(value) < 0) {
                    value = 0;
                }
                if (value > 0) {
                    if (this.quantityAllowed.min && value < this.quantityAllowed.min) {
                        value = 0;
                        this.form_error = 'Minimum ' + this.quantityAllowed.min;
                        var vm = this;
                        setTimeout(function(){ vm.form_error = null }, 5000);
                    }
                    else if (this.quantityAllowed.max && value > this.quantityAllowed.max) {
                        this.form_error = 'Maximum ' + this.quantityAllowed.max;
                        value = this.quantityAllowed.max;
                        var vm = this;
                        setTimeout(function(){ vm.form_error = null }, 5000);

                        if (event.target.tagName.toLowerCase() == 'select') {
                            value = 0;
                            var opts = event.target.childNodes;
                            for (var i=0;i<opts.length;i++) {
                                var v = opts[i].value;
                                if (v > value && v <= this.quantityAllowed.max) {
                                    value = opts[i].value;
                                }
                            }
                        }
                    }
                }
                this.$emit('input',parseInt(value),this.index);
            },

            remove: function() {
                this.$emit('remove',this);
            },

            showLargerImage: function() {
                if (!_.has(this.data,'supply_image_file') || !this.data.supply_image_file.replace('/img/supplies/','')) return;
                this.modal.modal('show');
            }
        },

        mounted: function() {
            if (mwl) mwl.attachFormControlUnderlining(this.$el);
            this.modal = $(this.$refs.modal);
        }
    }
</script>



// WEBPACK FOOTER //
// supply.vue?20981e1a